import { Fieldset, Grid, Modal, Space, Text } from '@mantine/core';
import { undefinedCheck } from '../util/undefinedCheck';
import { Title } from './Title';

type AddressModalProps = {
	isOpen: boolean;
	close: () => void;
	title?: string;
	street?: string;
	town?: string;
	area?: string;
	postCode?: string;
	county?: string;
};

export function AddressModal({
	isOpen,
	close,
	title,
	street,
	town,
	area,
	postCode,
	county,
}: AddressModalProps) {
	return (
		<>
			<Modal
				opened={isOpen}
				onClose={close}
				title={<Title label={title ?? 'Address'} />}
				centered
				size={'sm'}
			>
				<Fieldset legend="Address">
					<Grid>
						<Grid.Col span={12}>
							<Text fw={500}>Street</Text>
							<Text>{undefinedCheck(street)}</Text>
						</Grid.Col>
						<Grid.Col span={6}>
							<Text fw={500}>Post Code</Text>
							<Text>{undefinedCheck(town)}</Text>
						</Grid.Col>
						<Grid.Col span={6}>
							<Text fw={500}>Area</Text>
							<Text>{undefinedCheck(area)}</Text>
						</Grid.Col>
						<Grid.Col span={6}>
							<Text fw={500}>Town</Text>
							<Text>{undefinedCheck(postCode)}</Text>
						</Grid.Col>
						<Grid.Col span={6}>
							<Text fw={500}>County</Text>
							<Text>{undefinedCheck(county)}</Text>
						</Grid.Col>
					</Grid>
				</Fieldset>
				<Space h={20} />
			</Modal>
		</>
	);
}
